import { render, staticRenderFns } from "./actions.vue?vue&type=template&id=dec9c88e&scoped=true"
import script from "./actions.vue?vue&type=script&lang=js"
export * from "./actions.vue?vue&type=script&lang=js"
import style0 from "./actions.vue?vue&type=style&index=0&id=dec9c88e&prod&lang=scss"
import style1 from "./actions.vue?vue&type=style&index=1&id=dec9c88e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec9c88e",
  null
  
)

export default component.exports